import { CellContent } from '@cycle-app/ui';
import styled from 'styled-components';

export const StyledCellContent = styled(CellContent)`
  cursor: pointer;
`;
